/* global G */
import { set, reset } from 'lib/sequence/component/state/value'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { narrow, stretch } from 'lib/sequence/component/state/width'

/**
 * Controls the state of the row denoted by the `primary` and `secondary` fields.
 *
 * @param {boolean} undo whether to set or reset the state of the row
 *
 * @returns {function(Object, Gaia.AppModule.Spec, ...*): [Object,Gaia.AppModule.Spec, ...*]}
 */
export default undo => (data, module, ...args) => {
  const actionState = module[G.STATE][G.ACTION][G.STATE]
  const { secondary, primary, c } = data

  const isInitialized = c.component || c.parent
    ? actionState?.[c.parent || c.component]?.initAddress
    : actionState.initAddress

  if (undo) {
    hide(primary)
    stretch(secondary)
    reset(primary)
  } else {
    show(primary)
    narrow(secondary)

    // Only reset the primary field if we already went through initialisation
    isInitialized
      && set(primary, [])
  }

  return [data, module, ...args]
}
